"use client"

import { NEAR_X_PROMOTION_ID } from "@src/config/promotions"
import queryClient from "@src/constants/queryClient"
import { markPendingPromotionSwap } from "@src/features/promotions/lib/pendingSwapStorage"
import {
  type SwapSettlement,
  useSwapTrackerMachine,
} from "@src/providers/SwapTrackerMachineProvider"
import { useEffect } from "react"

// Root-mounted: turns generic swap settlements into NEAR@X pending-swap records
// and stats refreshes. All campaign identity/storage lives here, keeping the
// shared swap tracker campaign-agnostic.
export function PromotionSwapObserver() {
  const { subscribeToSettlements } = useSwapTrackerMachine()

  useEffect(
    () => subscribeToSettlements(recordPromotionSettlement),
    [subscribeToSettlements]
  )

  return null
}

export function recordPromotionSettlement(settlement: SwapSettlement): void {
  if (
    !settlement.isConfidential ||
    !settlement.succeeded ||
    settlement.accountId == null
  ) {
    return
  }

  markPendingPromotionSwap(
    { promotionId: NEAR_X_PROMOTION_ID, accountId: settlement.accountId },
    settlement.completedAt?.getTime()
  )
  void queryClient.invalidateQueries({
    queryKey: ["promotions", "stats", settlement.accountId],
  })
}
